import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel, Input } from '@chakra-ui/react';

interface IProps {
  label: string;
  id: string;
  value?: string;
  type?: string;
  onBlur: (key: string, value?: string) => void;
}

export const GroupTextV2 = ({ label, id, value, onBlur }: IProps) => {
  const [inputValue, setInputValue] = useState<string | undefined>(value);

  const onChange = (event: any) => {
    // removing all the letters and special characters
    setInputValue(event.target.value.replace(/\D/g, '').replace(/(\..*)\./g, '$1'));
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    // block any printable non-digit character (event.key.length === 1 excludes control keys like Backspace, ArrowLeft, etc.)
    if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();
    onBlur(id, inputValue);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <FormControl id={id} mb="4">
      <FormLabel>{label}</FormLabel>

      <Input
        value={inputValue || ''}
        type="number"
        step="1"
        min="0"
        data-selector={id}
        onBlur={handleOnBlur}
        onInput={onChange}
        onKeyDown={onKeyDown}
      />
    </FormControl>
  );
};
